import { Form, useForm } from '@/components/forms';
import Input from '@/components/forms/Input';
import { useDynamicLocale } from '@/hoslog-intl';
import { StaticDataTypeLabelDetail } from '@/services/staticDataTypeLabel/staticDataTypeLabel.types';
import { z } from 'zod';
import { useCreateStaticDataTypeLabel, useUpdateStaticDataTypeLabel } from './hooks/useStaticDataTypeLabelMutations';

const schema = z.object({
  staticDataLabel: z.string().min(1, { message: 'common.form.validation.required' }),
  staticDataDescription: z.string().min(1, { message: 'common.form.validation.required' }),
  staticDataValue: z.string().min(1, { message: 'common.form.validation.required' }),
  additionalValue1: z.string().min(1, { message: 'common.form.validation.required' }),
  additionalValue2: z.string().min(1, { message: 'common.form.validation.required' }),
  additionalValue3: z.string().min(1, { message: 'common.form.validation.required' }),
  additionalValue4: z.string().min(1, { message: 'common.form.validation.required' }),
  inputType: z.string().min(1, { message: 'common.form.validation.required' }),
});

export const ManageStaticDataTypeLabelView = ({
  staticDataTypeId,
  staticDataLabelId,
  staticDataLabel,
}: {
  staticDataTypeId?: string;
  staticDataLabelId?: string;
  staticDataLabel?: StaticDataTypeLabelDetail;
}) => {
  const form = useForm({
    schema,
    mode: 'onBlur',
    defaultValues: {
      staticDataLabel: staticDataLabel?.staticDataLabel ?? '',
      staticDataDescription: staticDataLabel?.staticDataDescription ?? '',
      staticDataValue: staticDataLabel?.staticDataValue ?? '',
      additionalValue1: staticDataLabel?.additionalValue1 ?? '',
      additionalValue2: staticDataLabel?.additionalValue2 ?? '',
      additionalValue3: staticDataLabel?.additionalValue3 ?? '',
      additionalValue4: staticDataLabel?.additionalValue4 ?? '',
      inputType: staticDataLabel?.inputType ?? '',
    },
  });
  const { t } = useDynamicLocale();
  const { mutateAsync: createStaticDataLabel } = useCreateStaticDataTypeLabel();
  const { mutateAsync: updateStaticDataLabel } = useUpdateStaticDataTypeLabel();

  console.log(staticDataTypeId);

  return (
    <Form
      form={form}
      onSubmit={async (data) => {
        if (staticDataLabelId) {
          await updateStaticDataLabel({
            staticDataTypeId: staticDataTypeId,
            staticDataLabelId: staticDataLabelId,
            ...data,
          });
        } else
          await createStaticDataLabel({
            staticDataTypeId: staticDataTypeId,
            ...data,
          });
      }}
    >
      <div className="w-full flex flex-col gap-4.5">
        <Input
          label="logsManagement.staticDataTypeLabel.manageStaticDataTypeLabel.label.staticDataLabel"
          maxLength={50}
          placeholder={t('logsManagement.staticDataTypeLabel.manageStaticDataTypeLabel.label.staticDataLabel')}
          {...form.register('staticDataLabel')}
        />
        <Input
          label="logsManagement.staticDataTypeLabel.manageStaticDataTypeLabel.label.staticDataDescription"
          maxLength={50}
          placeholder={t('logsManagement.staticDataTypeLabel.manageStaticDataTypeLabel.label.staticDataDescription')}
          {...form.register('staticDataDescription')}
        />
        <Input
          label="logsManagement.staticDataTypeLabel.manageStaticDataTypeLabel.label.staticDataValue"
          maxLength={50}
          placeholder={t('logsManagement.staticDataTypeLabel.manageStaticDataTypeLabel.label.staticDataValue')}
          {...form.register('staticDataValue')}
        />
        <Input
          label="logsManagement.staticDataTypeLabel.manageStaticDataTypeLabel.label.additionalValue1"
          maxLength={50}
          placeholder={t('logsManagement.staticDataTypeLabel.manageStaticDataTypeLabel.label.additionalValue1')}
          {...form.register('additionalValue1')}
        />
        <Input
          label="logsManagement.staticDataTypeLabel.manageStaticDataTypeLabel.label.additionalValue2"
          maxLength={50}
          placeholder={t('logsManagement.staticDataTypeLabel.manageStaticDataTypeLabel.label.additionalValue2')}
          {...form.register('additionalValue2')}
        />
        <Input
          label="logsManagement.staticDataTypeLabel.manageStaticDataTypeLabel.label.additionalValue3"
          maxLength={50}
          placeholder={t('logsManagement.staticDataTypeLabel.manageStaticDataTypeLabel.label.additionalValue3')}
          {...form.register('additionalValue3')}
        />
        <Input
          label="logsManagement.staticDataTypeLabel.manageStaticDataTypeLabel.label.additionalValue4"
          maxLength={50}
          placeholder={t('logsManagement.staticDataTypeLabel.manageStaticDataTypeLabel.label.additionalValue4')}
          {...form.register('additionalValue4')}
        />
        <Input
          label="logsManagement.staticDataTypeLabel.manageStaticDataTypeLabel.label.inputType"
          maxLength={50}
          placeholder={t('logsManagement.staticDataTypeLabel.manageStaticDataTypeLabel.label.inputType')}
          {...form.register('inputType')}
        />
      </div>
    </Form>
  );
};
